import { useProductOptionFormModelContext } from "../context";
import { QuestionOptionBase } from "./base/root";
import { QuestionOptionCancelPolicy } from "./cancel-policy/root";
import { QuestionOptionDiscountSetting } from "./discount-setting/root";
import { QuestionOptionAttributes } from "./optional-attributes/root";
import { QuestionOptionPlanRestrictionsAndConnection } from "./plan-restrictions-and-connection/root";
import { QuestionOptionSalesTerm } from "./sales-term/root";
import { QuestionOptionSalesTypeAndPrice } from "./sales-type-and-price/root";
import { QuestionOptionStock } from "./stock/root";
import { QuestionOptionSubOption } from "./sub-option/root";

import type { StandardOptionCategoriesAndManagerStore } from "../store/categories";

type Props = {
	roomCategoriesAndManagerStore: Omit<
		StandardOptionCategoriesAndManagerStore,
		"categoryManagerStore" | "categoryStoreArray"
	>;
};

export const OptionForm = ({ roomCategoriesAndManagerStore }: Props) => {
	const { hotelID, optionID } = useProductOptionFormModelContext().viewModel;

	const {
		base,
		salesTypeAndPrice,
		planRestrictionsAndConnection,
		discountSetting,
		subOption,
		stock,
		salesTerm,
		cancelPolicy,
		optionAttributes,
	} = roomCategoriesAndManagerStore;

	return (
		<>
			<QuestionOptionBase base={base} hotelID={hotelID} optionID={optionID} />
			<QuestionOptionSalesTypeAndPrice salesTypeAndPrice={salesTypeAndPrice} />
			<QuestionOptionPlanRestrictionsAndConnection
				planRestrictionsAndConnection={planRestrictionsAndConnection}
			/>
			<QuestionOptionDiscountSetting discountSetting={discountSetting} />
			<QuestionOptionStock stock={stock} />
			<QuestionOptionSalesTerm salesTerm={salesTerm} />
			<QuestionOptionCancelPolicy cancelPolicy={cancelPolicy} />
			<QuestionOptionAttributes optionAttributes={optionAttributes} />
			<QuestionOptionSubOption subOption={subOption} />
		</>
	);
};

OptionForm.displayName = "OptionForm";
